import React, { useState, useEffect } from 'react'
import PropTypes from "prop-types";
import { HTTP } from '../../api/resources';
import IncreaseLimit from './Modals/IncreaseLimit';
import InfoModal from './Modals/InfoModal';
import QuickView from './QuickView';
import MediaWarning from './Modals/MediaWarning';
import NoMediaGenerated from './Modals/NoMediaGenerated';

function PostList(props) {
    const [route, setRoute] = useState('/group/post/settings')
    const [routeTitle, setRouteTitle] = useState('+ Create Multiple Posts')
    const [posts, setPosts] = useState([])
    const [dropDown, setDropDown] = useState(false)
    const [basic, setBasic] = useState(true)
    const [saving, setSaving] = useState(false)
    const [uploadedPostCount, setUploadedPostCount] = useState(0)
    const [showEmpty, setShowEmpty] = useState(false)
    const [openLimit, setOpenLimit] = useState(false)
    const [groupPost, setGroupPost] = useState(props.post)
    const [openQuickView, setOpenQuickView] = useState(null)
    const [openMediaGuide, setOpenMediaGuide] = useState(false)
    const [renderedPosts, setRenderedPosts] = useState([])
    const [openMediaWarning, setOpenMediaWarning] = useState(false)
    const [openInfo, setOpenInfo] = useState(false)
    const [openInstructions, setOpenInstructions] = useState(false)
    const [remainder, setRemainder] = useState(0)

    const user = props.user
    const users = props.users
    const post = props.empty_post
    const team = props.team

    // check group post status
    useEffect(() => {
        checkStatus()
        checkPostCount()
    }, [[groupPost, uploadedPostCount]])

    useEffect(() => {
        if (groupPost?.posts?.length) {
            const newRender = groupPost.posts.map((p, index) => ({
                ...p,
                key: `${p.id || 'post'}-${index}`,
            }));
            setRenderedPosts(newRender);
        }
    }, [groupPost]);

    function removeRemainderParam() {
        const url = new URL(window.location.href);
        url.searchParams.delete('remainder');
        window.history.replaceState({}, '', url);
    }


    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        let count = Number(searchParams.get('remainder') || 0);
        setRemainder(count)
        if (count > 0) {
            setOpenInfo(true)
        } else if (groupPost && groupPost.smart_post_setup && (!groupPost.posts || groupPost.posts < 1)) {
            setOpenInfo(true)
        }
    }, [])

    const checkPostCount = () => {
        if (!groupPost) {
            setShowEmpty(true)
        } else if (groupPost && !groupPost.posts) {
            setShowEmpty(true)
        } else {
            setShowEmpty(false)
        }
    }

    const checkStatus = () => {
        if (groupPost) {
            if (groupPost.posts && groupPost.posts.length == groupPost.limit) {
                setBasic(false)
            } else {
                setRouteTitle('Continue')
                setRoute('/group/post/media')
                setDropDown(true)
            }

            if (groupPost.smart_post_setup) {
                setBasic(false)
            }
        }
    }

    // delete all post
    const deleteAllPost = async () => {
        try {
            await deletePost()
        } catch {
            Alert.show('error', 'Error deleting posts, try again')
            return ''
        }

        setSaving(false)
        Alert.show('notice', 'Successfully deleted all posts')
        setTimeout(() => {
            window.location.reload()
        }, 1500)
    }

    useEffect(() => {}, [saving])

    const deletePost = () => {
        return HTTP.delete('/group/post')
    }

    // delete single post
    const handleDelete = async (data) => {
        try {
            await updateList(data)
        } catch {
            Alert.show('error', 'Error delete post, try again')
            return ''
        }

        Alert.show('success', 'Post deleted successfully')
        setTimeout(() => {
            window.location.reload()
        }, 1500)
    }

    // update post list
    const updateList = (data) => {
        return HTTP.delete(`post/${data.id}`)
    }

    // upload post only
    const handleSave = async (current) => {
        let data = { post: post }
        data.post.title = current.title
        data.post.content = current.content
        data.post.published_at = current.date
        data.post.ordered_file_ids = []
        data.post.audience_members = current.audience
        data.post.user_id = current.owner.id
        data.post.ordered_file_ids = current.files.map((file)=>file.blob_id || file.id)
        data.post.files = current.files
        data.post.post_type = current.post_type
        data.post.public_project_audience = current.public_project_audience
        let postId = post.id;
        let ownerId = current.owner.id

        try {
            let response = await saveNewPost(data);
            postId = response.data.id;
          } catch {
            Alert.show("error", "Could not save. Try again or refresh.")
            return false
          }

          return true
      }


    // Upload all posts and approve
    const handleSaveAndApprove = async (current) => {
        let data = { post: post }
        data.post.title = current.title
        data.post.content = current.content
        data.post.published_at = current.date
        data.post.ordered_file_ids = []
        data.post.audience_members = current.audience
        data.post.user_id = current.owner.id
        data.post.ordered_file_ids = current.files.map((file)=>file.blob_id || file.id)
        data.post.files = current.files
        data.post.post_type = current.post_type
        data.post.public_project_audience = current.public_project_audience
        let postId = post.id;
        let ownerId = current.owner.id

        try {
            let response = await saveNewPost(data);
            postId = response.data.id;
          } catch {
            Alert.show("error", "Could not save. Try again or refresh.")
            return false
          }

          await approvePost(postId, ownerId);
          return true
      }

    //   Approve post http request
      const approvePost = async (postId, user_id) => {
        return HTTP.patch(`/users/${user_id}/posts/${postId}/approve`, {
          approved: 'approve',
        })
      }

    //   Save new post http request
      const saveNewPost = async (data) => {
        return HTTP.post(`/users/${data.post.user_id}/posts.json`, data)
      }

    //   upload post and approve event function
    const uploadPostApprove = async () => {
        setSaving(true)
        Alert.show('notice', 'Please wait while we upload your posts')

        for (let x = 0; x < groupPost.posts.length; x++) {
            let current = groupPost.posts[x]
            const result = await handleSaveAndApprove(current)
            if (result == false) {
                Alert.show('error', 'Error uploading posts, try again')
                setSaving(false)
                return ''
            }
        }


        Alert.show('notice', `All posts have been uploaded and approved, clearing group...`)
        setTimeout(() => {
            deleteAllPost()
        }, 3000)
    }

    // upload post only event function
    const uploadPosts = async () => {
        if (!groupPost.posts || groupPost.posts.length < 1) {
            Alert.show('notice', 'No post to upload')
            return 
        }

        setSaving(true)
        Alert.show('notice', 'Please wait while we upload your posts')

        for (let x = 0; x < groupPost.posts.length; x++) {
            let current = groupPost.posts[x]
            const result = await handleSave(current)
            if (result == false) {
                Alert.show('error', 'Error uploading posts, try again')
                setSaving(false)
                return ''
            }
        }


        Alert.show('notice', `All posts have been uploaded, clearing group...`)
        setTimeout(() => {
            deleteAllPost()
        }, 3000)
    }

    window.onbeforeunload = (e) => {
        if (saving) {
            return ''
        }
    }

    // show post audience 
    const showAudience = (audience) => {
        if (!audience || audience.length < 1) return 'All attached users'.toLowerCase()
        return audience.map((audience) => audience.name).join(', ').toLowerCase()
    }

    // truncate text to 20 characters at a time 
    const truncateText = (text) => {
        if (text.length > 20) {
            return text.substring(0, 40) + '...'
        }
        return text
    }

    // end post at the current number
    const endPost = async () => {
        if (!groupPost.posts || groupPost.posts.length < 1) {
            Alert.show('error', 'You have to create at least one post to end the multi-post here')
            return false 
        }

        setSaving(true)
    
        try {
            await patchRequest(groupPost.posts.length)
            Alert.show('notice', 'Post ended successfully, reloading...')
            setTimeout(() => window.location.reload(), 1500)
        } catch {
            Alert.show('error', 'Failed to end post, try again')
            setSaving(false)
        }
    }

    const patchRequest = (count) => {
        return HTTP.patch(`/group/post/limit/${count}`)
    }

    const updateUseTemplate = async () => {
        setSaving(true)
        let action = groupPost.use_template ? 'deactivate' : 'activate'
    
        try {
          let response = await templateRequest(action)
          setGroupPost({...groupPost, use_template: response.data})
          Alert.show('notice', 'Default template status updated successfully')
          setSaving(false)
        } catch {
          Alert.show('error', 'Unable to update default template status, please try again')
          setSaving(false)
        }
      }
    
      const templateRequest = (action) => {
        return HTTP.post(`/group/post/settings/use_template?type=${action}`)
      }

      const updateAutoSelectMedia = async () => {
        if (!groupPost.auto_select_media) {
          setOpenMediaGuide(true)
        }
    
        setSaving(true)
        let action = groupPost.auto_select_media ? 'deactivate' : 'activate'
    
        try {
          let response = await AutoSelectRequest(action)
          setGroupPost({...groupPost, auto_select_media: response.data})
          Alert.show('notice', 'Success! It will take effect in the next post.')
          setSaving(false)
        } catch {
          Alert.show('error', 'Unable to update, please try again')
          setSaving(false)
        }
      }
    
      const AutoSelectRequest = (action) => {
        return HTTP.post(`/group/post/settings/auto_select_media?type=${action}`)
      }

      const updatePost = async (post) => {
          setSaving(true)
      
          // validations
          if (post.post_type == 'project' && (!post.audience || post.audience.length !== 1)) {
            Alert.show('notice', `You must select one audience for a ${team.project_title.toLowerCase()} post`)
            setSaving(false)
            return
          }

          let data = groupPost.posts

          data = data.map(p => {
            if (p.id === post.id) {
                return post
            }
            return p
          })

          const posts = {
            posts: data
          }
      
          try {
            let response = await save(posts)
            setGroupPost(response.data)
            setSaving(false)
            Alert.show('notice', 'Posts saved successfully')
            return true
          } catch {
            Alert.show('error', 'Error saving posts, try again')
            setSaving(false)
            return false
          }
        }
      
        const save = (data) => {
          return HTTP.patch('/group/post/form', data)
        }


  return (
    <div>
        <div className="card">
            <div className="card-header flex-header">
                <h4 className="card-title">
                Multiple Posts
                </h4>
                {saving &&
                    <div class="btn-group">
                     <a href="#" className="btn btn-primary" onClick={() => {Alert.show('notice', 'Please wait while we process your request')}}>Processing...</a>
                    </div>
                }
                {basic && !saving &&
                    <div class="btn-group">
                        <a href={ route } className="btn btn-primary"> { routeTitle }</a>
                        {dropDown  &&
                            <>
                            <button type="button" className="btn btn-primary btn-narrow dropdown-toggle dropdown-toggle-split btn-split-right" data-toggle="dropdown" aria-expanded="false">
                                <span className="sr-only">Toggle Dropdown</span>
                            </button>
                            <ul className="dropdown-menu dropdown-menu-right">
                                {groupPost.posts && groupPost.posts.length > 0 &&
                                <div>
                                    <li>
                                    <button
                                    onClick={uploadPosts}
                                    name="button"
                                    className="dropdown-item"
                                    type="button">
                                    {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                                        Upload Posts
                                    </button>
                                    </li>
                                    {user.user_type !== 'sponsorship_manager' &&
                                        <li>
                                            <button
                                            onClick={uploadPostApprove}
                                            name="button"
                                            className="dropdown-item"
                                            type="button">
                                            {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                                                Upload and Approve
                                            </button>
                                        </li>
                                    }
                                </div>
                                }
                                {groupPost.use_media && !groupPost.smart_post_setup &&
                                    <li>
                                        <button
                                        onClick={updateAutoSelectMedia}
                                        name="button"
                                        className="dropdown-item"
                                        type="button">
                                            {groupPost.auto_select_media ? 'Deactivate Auto-Select Media' : "Activate Auto-Select Media"}
                                        </button>
                                    </li>
                                }
                                {groupPost.template_id && !groupPost.smart_post_setup &&
                                    <li>
                                        <button
                                        onClick={updateUseTemplate}
                                        name="button"
                                        className="dropdown-item"
                                        type="button">
                                            {groupPost.use_template ? 'Deactivate Default Template' : "Activate Default Template"}
                                        </button>
                                    </li>
                                }

                                {!groupPost.smart_post_setup && 
                                    <li>
                                        <button
                                        onClick={() => setOpenLimit(true)}
                                        name="button"
                                        className="dropdown-item"
                                        type="button">
                                            Adjust Limit
                                        </button>
                                    </li>
                                }

                                <li>
                                    <button
                                    onClick={endPost}
                                    name="button"
                                    className="dropdown-item"
                                    type="button">
                                        End Post
                                    </button>
                                </li>

                                <li>
                                <button
                                    name="button"
                                    className="dropdown-item"
                                    type="button">
                                    <span className="text-danger" onClick={() => {if( window.confirm('Are you sure you want to delete all posts')) deleteAllPost()}}>
                                        Delete Posts
                                    </span>
                                </button>
                                </li>
                            </ul>
                            </>
                        }
                    </div>}

                    {/* advanced buttons */}
                    {!basic && !saving &&
                    <div class="btn-group">
                        <a href="#" className="btn btn-primary" onClick={uploadPosts}>
                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                            Upload Posts
                        </a>
                            <>
                            <button type="button" className="btn btn-primary btn-narrow dropdown-toggle dropdown-toggle-split btn-split-right" data-toggle="dropdown" aria-expanded="false">
                                <span className="sr-only">Toggle Dropdown</span>
                            </button>
                            <ul className="dropdown-menu dropdown-menu-right">
                                {user.user_type !== 'sponsorship_manager' &&
                                    <li>
                                        <button
                                        onClick={uploadPostApprove}
                                        name="button"
                                        className="dropdown-item"
                                        disabled={!groupPost.posts || groupPost.posts.length < 1}
                                        type="button">
                                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                                            Upload and Approve
                                        </button>
                                    </li>
                                }
                                {!groupPost.smart_post_setup && 
                                    <li>
                                        <button
                                        onClick={() => setOpenLimit(true)}
                                        name="button"
                                        className="dropdown-item"
                                        type="button">
                                            Ajust Limit
                                        </button>
                                    </li>
                                }
                                {groupPost.smart_post_setup && 
                                    <li>
                                        <button
                                        onClick={() => setOpenMediaWarning(true)}
                                        name="button"
                                        className="dropdown-item"
                                        type="button">
                                            Edit Media Files
                                        </button>
                                    </li>
                                }
                                <li>
                                <button
                                    name="button"
                                    className="dropdown-item"
                                    type="button">
                                    <span className="text-danger" onClick={() => {if( window.confirm('Are you sure you want to delete all posts')) deleteAllPost()}}>
                                        Delete Posts
                                    </span>
                                </button>
                                </li>
                            </ul>
                            </>
                    </div>}
            </div>
        </div>


        {groupPost && groupPost.smart_post_setup && 
            <div style={{textAlign: 'right'}} className='mb-3'>
                <i className="fas fa-question-circle mr-2 text-secondary-icon cursor-cu"></i><a href='#' onClick={() => setOpenInstructions(true)}>See Automatic Posting Guide</a>
            </div>
        }

        {groupPost && groupPost.posts && groupPost.posts.length > 0 &&
            <div className="page-header">
                <h4 className="page-title">
                    Posts
                </h4>
                <ul className="breadcrumbs">
                    <li className="nav-item">
                        All ({groupPost.posts.length})
                    </li>
                </ul>
            </div>
        }

        <div className="card">
        {groupPost && groupPost.posts && groupPost.posts.length > 0 && renderedPosts && renderedPosts.length > 0 &&
            <div>
            <div className="list-group list-group-flush">
                {renderedPosts.map((post, index) => (
                <div key={post.key}>
                    <div className="list-group-item">
                        <div className='list-group-item-body'>
                        <div className='list-group-item-body-main'>
                            <p style={{ marginBottom: '0px' }}>{post.title}</p>
                        </div>
                        </div>
                        <div className='list-group-item-actions'>
                        <div>
                            <a href="#" className="btn btn-sm btn-outline-primary" onClick={() => setOpenQuickView(!openQuickView || openQuickView !== post.key ? post.key : null)}>
                                Quick View <i 
                                class={openQuickView && openQuickView == post.key ? `card--accordion-icon fa fa-chevron-up` : `card--accordion-icon fa fa-chevron-down`}></i>
                            </a>
                            <div className="btn-group">
                                <a 
                                    href={`post/edit/${post.id}`} 
                                    className="btn btn-sm btn-primary ml-2"
                                    style={{marginRight: '0px'}}
                                >
                                    <i className="fa fa-pencil"></i> 
                                    Edit Post
                                </a>
                                <>
                                    <button 
                                        type="button" 
                                        className="btn btn-sm btn-primary btn-narrow dropdown-toggle dropdown-toggle-split btn-split-right" 
                                        data-toggle="dropdown" 
                                        aria-expanded="false"
                                    >
                                        <span className="sr-only">Toggle Dropdown</span>
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-right">
                                        <div>
                                            <li>
                                                <button
                                                    onClick={() => {if (window.confirm('Are you sure you want to delete this post')) handleDelete(post)}}
                                                    name="button"
                                                    className="dropdown-item text-danger"
                                                    type="button">
                                                    Remove
                                                </button>
                                            </li>
                                        </div>
                                    </ul>
                                </>
                            </div>
                        </div>
                        </div>
                    </div>

                    {openQuickView && openQuickView == post.key &&
                        <div style={{height: 'fit-content !important', padding: '0.75rem 1.25rem'}}>
                            <QuickView 
                                post={post} 
                                team={team} 
                                postSkin={post}
                                proceed={(post) => updatePost(post)}
                                availableAudiences={props.availableAudiences}
                                user={user}
                                groupPost={groupPost}
                                users={users}
                                saving={saving}
                            />
                        </div>
                    }
                </div>
                ))}
            </div>
            </div>
        }

            {showEmpty &&
                <div className="card-body">
                    Let's get started with your first post :)
                </div>
            }
            
        </div>

        {openLimit &&
            <IncreaseLimit 
                post={{id: groupPost.id, user_id: groupPost.user_id, limit: groupPost.limit}}
                close={(limit = null) => {
                    if (limit) {
                        setGroupPost({...groupPost, limit: limit})
                        window.location.reload()
                    }
                    setOpenLimit(false)
                }}
                postCount={groupPost.posts.length ? groupPost.posts.length : 0}
            />
        }

        {openMediaGuide && 
            <InfoModal team={props.team} close={() => setOpenMediaGuide(false)} />
        }

        {openMediaWarning &&
            <MediaWarning close={() => setOpenMediaWarning(false)} />
        }

        {openInfo &&
            <NoMediaGenerated 
                close={() => {
                    setOpenInfo(false);
                    removeRemainderParam();
                }} 
                remainder={remainder} 
            />
        }

        {openInstructions &&
            <InfoModal team={team} close={() => setOpenInstructions(false)} type='smart-post'/>
        }
    </div>
  )
}

export default PostList
